/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkplaceLocation
 */
export interface WorkplaceLocation {
    /**
     * 
     * @type {PostalAddress}
     * @memberof WorkplaceLocation
     */
    location: PostalAddress;
    /**
     * 
     * @type {number}
     * @memberof WorkplaceLocation
     */
    radius: number;
}

/**
 * Check if a given object implements the WorkplaceLocation interface.
 */
export function instanceOfWorkplaceLocation(value: object): value is WorkplaceLocation {
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('radius' in value) || value['radius'] === undefined) return false;
    return true;
}

export function WorkplaceLocationFromJSON(json: any): WorkplaceLocation {
    return WorkplaceLocationFromJSONTyped(json, false);
}

export function WorkplaceLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkplaceLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'location': PostalAddressFromJSON(json['location']),
        'radius': json['radius'],
    };
}

export function WorkplaceLocationToJSON(value?: WorkplaceLocation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'location': PostalAddressToJSON(value['location']),
        'radius': value['radius'],
    };
}

